import React from 'react';
import { Button } from 'react-bootstrap';
import AwardsFilterDropdown from '../Awards/AwardsListDropdown';
//import RewardsListDropdown from '../ReportingManagerDetails/RewardsListDropdown';
import { RiDeleteBin2Fill } from 'react-icons/ri';
import { Award } from '../Awards/rnr.types';

// Define the shape of the props this component will receive
interface AwardEligibilityFilterProps {
    selectedAward: Award | null;
    onAwardSelect: (award: Award | null) => void;
    awards: Award[];
}

const AwardEligibilityFilter = ({ selectedAward, onAwardSelect, awards }: AwardEligibilityFilterProps) => {
    return (
        <div className="d-flex align-items-center">
            <div className="d-flex flex-col align-items-center flex-wrap">
                <span style={{ marginRight: '8px'}}>Filter by award eligibility:</span>
                {/* Component */}
                {/* <RewardsListDropdown 
                    selectedAward={selectedAward}
                    onAwardSelect={onAwardSelect} 
                    awards={awards}                
                /> */}
                <AwardsFilterDropdown 
                    selectedAward={selectedAward}
                    onAwardSelect={onAwardSelect} 
                    awards={awards}                
                />
                {selectedAward && (
                <Button 
                    variant="outline-danger" 
                    size="sm"
                    onClick={() => onAwardSelect(null)}
                    className='ms-2'
                >
                    <RiDeleteBin2Fill size={20} />
                </Button>
                )}
            </div>
        </div>
    );
};

export default AwardEligibilityFilter;